import script from "./status-change.vue?vue&type=script&setup=true&lang=js"
export * from "./status-change.vue?vue&type=script&setup=true&lang=js"

import "./status-change.vue?vue&type=style&index=0&id=c8b72970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8b72970"]])

export default __exports__